// @ts-nocheck
import { DropDownFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import { blockVariantOptions } from "@store/Components/Toolkit/Block/variant/config";
import { getDataOptionsFieldDefinition } from "@store/Framework/Common/Utilities/dataOptions";

const blockVariantField = {
    ...getDataOptionsFieldDefinition(blockVariantOptions),
    displayName: "Variant",
} as DropDownFieldDefinition<string>;

export default blockVariantField;
